import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'app/providers/Store';

const getUsersState = (state: RootState) => state.users;

export const usersSelectors = {
  getUsers: createSelector(
    getUsersState,
    (usersState) => usersState.users,
  ),

  getUsersLoading: createSelector(
    getUsersState,
    (usersState) => usersState.isLoading,
  ),

  getUserDetail: createSelector(
    getUsersState,
    (usersState) => usersState.userDetail.data,
  ),

  getUserDetailLoading: createSelector(
    getUsersState,
    (usersState) => usersState.userDetail.isLoading,
  ),
};
